import { render, staticRenderFns } from "./Subasignacion.vue?vue&type=template&id=7b5a6e06"
import script from "./Subasignacion.vue?vue&type=script&lang=js"
export * from "./Subasignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports